import Vue from "vue";
import Vuex from "vuex";
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import { db, auth } from '@/plugins/db'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    media: [],
    dialog: false,
    locked: false,
    fullscreenMode: false,
    barOnTop: false,
    query: ''
  },
  mutations: {
    closeAddDialog: (state) => {
      state.dialog = false
    },
    openAddDialog: (state) => {
      state.dialog = true
    },
    setUser: (state, payload) => {
      state.user = payload
    },
    setLocked: (state, payload) => {
      state.locked = payload
    },
    toggleFullscreen: (state) => {
      state.fullscreenMode = !state.fullscreenMode
    },
    toggleBarLocation: (state) => {
      state.barOnTop = !state.barOnTop
    },
    setQuery: (state, payload) => {
      state.query = payload
    },
    ...vuexfireMutations
  },
  actions: {
    bindMedia: firestoreAction(({ bindFirestoreRef }, payload) => {
      return bindFirestoreRef('media', db.collection('media').where('uid', '==', payload).orderBy('order'))
    }),
    addMedia: firestoreAction(({commit}, payload) => {
      return db.collection('media').doc(payload.id).set(payload.medium).then(() => commit('closeAddDialog'))
    }),
    updateMedia: firestoreAction((context, payload) => {
      return db.collection('media').doc(payload.id).update(payload.medium)
    }),
    destroyMedia: firestoreAction((context, payload) => {
      if (window.confirm('are you sure')) {
        db.collection('media')
          .doc(payload)
          .delete()
      }
    }),
    async login(context, { email, password }) {
      await auth.signInWithEmailAndPassword(email, password)
    },
    async logout() {
      await auth.signOut()
    }
  },
  getters: {
    totalMedia: (state) => state.media.length,
    searchedMedia: (state) => state.media.filter((medium) => {
      return medium.type !== 'divider' && medium.title.toLowerCase().includes(state.query.toLowerCase())
    })
  }
});
